import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';

async function getFile(axios: AxiosInstance, url: string, isV2?: boolean) {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/${isV2 ? 'v2' : 'v1'}/${url}`, {
    responseType: 'arraybuffer',
  });
  return data;
}

export default function useFileQuery(url: string, isV2?: boolean) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(url),
    queryFn: () => getFile(axios, url, isV2),
    enabled: !!url,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error as any));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

export function getKey(url: string) {
  return ['File', url] as const satisfies QueryKey;
}

useFileQuery.getKey = getKey;
